import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { BankRepository } from "../domain/BankRepository";
import { Bank } from "../domain/Bank";

export function createApiBankRepository(): BankRepository {
  return new APIBankRepository();
}

export class APIBankRepository
  extends APIRepository
  implements BankRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getBanksByCountry(company_uid:string,country_code: string): Promise<Bank[]> {
    console.log("getBanksByCountry country_code: " + country_code);
    return this.doGet<Bank[]>("/api/banks/company/" +company_uid + "/countryCode/" + country_code.toString());
  }

}
